<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
  [noSubmitBtn]="form.controls.type.value === null"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  @if (!entity.type) {
    <div
      class="form-step form-step-before"
      [ngClass]="{ left: form.controls.type.value != null }"
    >
      <h3 class="drawer-title">Investissement private equity</h3>
      <ul>
        @for (product of products; track product) {
          <li class="pointer choose-button" (click)="selectType(product.id)">
            {{ product.label }}
          </li>
        }
      </ul>
    </div>
  }

  <div
    class="form-step"
    [ngClass]="{ right: form.controls.type.value == null }"
  >
    <input formControlName="id" type="hidden" />

    <pr-tabs
      clazz="drawer-tab-button"
      [defaultTextColor]="false"
      [changeTab]="changeTab"
      (lastTab)="onTabChange($event)"
    >
    <pr-tab label="Informations générales">
      <pr-input [label]="'Montant investi'" [suffix]="'€'" [derrors]="derrors">
        <input formControlName="purchasePrice" type="text" />
      </pr-input>

      <pr-input-date
        formControlName="startDate"
        label="Date d’acquisition"
        [derrors]="derrors"
      ></pr-input-date>

      <pr-input-autosuggest
        formControlName="contratId"
        label="Gestionnaire"
        [options]="managers"
        [derrors]="derrors"
        [optionLabel]="'name'"
      >
        <span customOptionText
          >Ce gestionnaire sera créé lors de l'enregistrement.</span
        >
      </pr-input-autosuggest>

      <pr-input [label]="'Nom de l’entreprise'" [derrors]="derrors">
        <input formControlName="label" type="text" />
      </pr-input>

      <pr-input [label]="'Valeur actuelle'" [suffix]="'€'" [derrors]="derrors">
        <input formControlName="lastValue" type="text" />
      </pr-input>

      <pr-input label="Durée prévisionnelle" [derrors]="derrors">
        <mat-select formControlName="duration">
          @for (year of _.range(15); track year; let i = $index) {
            <mat-option [value]="i + 1">
              {{ i + 1 + (i == 0 ? ' an' : ' ans') }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input-radio
        formControlName="pmeAllowDefiscalisation"
        label="Cet investissement donne droit à une défiscalisation ?"
        toggleBgEmpty="true"
      ></pr-input-radio>

      <pr-input
        [label]="'Taux de réduction'"
        [suffix]="'%'"
        [derrors]="derrors"
        *ngIf="form.controls.pmeAllowDefiscalisation.value"
      >
        <input formControlName="taxReductionRate" type="text" />
      </pr-input>

      <pr-input-date
        formControlName="endDate"
        label="Date de clôture"
        [derrors]="derrors"
      ></pr-input-date>
    </pr-tab>
    <pr-tab label="Détention">
      <pr-input label="Acquis au travers de" [derrors]="derrors">
        <mat-select formControlName="subscriptionSource">
          @for (item of sources; track item) {
            <mat-option [value]="item.id">
              {{ item.label }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input-owner-share
        formControlName="owners"
        [derrors]="derrors"
      ></pr-input-owner-share>
    </pr-tab>
    </pr-tabs>
  </div>
</pr-form>
